<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="提现列表" name="list">
        <el-form :inline="true">
          <el-form-item label="店铺ID">
            <el-input
              v-model="query.shop_id"
              placeholder="店铺ID"
              clearable
              style="width: 130px"
            ></el-input>
          </el-form-item>
          <el-form-item label="提现单号">
            <el-input
              v-model="query.order_no"
              placeholder="精确匹配"
              clearable
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="query.status" placeholder="选择" clearable>
              <el-option
                v-for="(item, i) in statusOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打款渠道">
            <el-select v-model="query.pay_channel" placeholder="选择" clearable>
              <el-option label="支付宝(线上)" :value="1"></el-option>
              <el-option label="银行卡(人工)" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="query.createTime"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="待人工打款" name="wait">
        <el-form :inline="true">
          <el-form-item label="店铺ID">
            <el-input
              v-model="waitQuery.shop_id"
              placeholder="店铺ID"
              clearable
              style="width: 130px"
            ></el-input>
          </el-form-item>
          <el-form-item label="提现单号">
            <el-input
              v-model="waitQuery.order_no"
              placeholder="精确匹配"
              clearable
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #pay_channel="{ row }">
        <el-tag size="small" v-if="row.pay_channel === 1">支付宝(线上)</el-tag>
        <el-tag size="small" type="warning" v-if="row.pay_channel === 2"
          >银行卡(人工)</el-tag
        >
      </template>
      <template #payee="{ row }">
        <div>{{ (row.payee_type === 3 ? "银行卡" : "支付宝") + "·" + row.payee_name }}</div>
        <div>{{ row.payee_account_masked }}</div>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="warning" v-if="row.status === 0"
          >待审核</el-tag
        >
        <el-tag size="small" v-if="row.status === 1">打款中</el-tag>
        <el-tag size="small" type="danger" v-if="row.status === 2"
          >已拒绝</el-tag
        >
        <el-tag size="small" type="success" v-if="row.status === 3"
          >提现成功</el-tag
        >
        <el-tag size="small" type="danger" v-if="row.status === 4"
          >提现失败</el-tag
        >
        <el-tag size="small" type="warning" v-if="row.status === 5"
          >待人工打款</el-tag
        >
        <el-tag size="small" type="info" v-if="row.status === 6">已撤销</el-tag>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="primary" @click="openDetail(row)"
          >详情</el-button
        >
        <el-button
          size="small"
          type="success"
          v-if="row.status === 0"
          @click="openAudit(row)"
          >审核</el-button
        >
        <el-button
          size="small"
          type="warning"
          v-if="row.status === 1 && row.pay_channel === 1"
          @click="retryTransfer(row)"
          >重试打款</el-button
        >
        <el-button
          size="small"
          type="success"
          v-if="row.status === 5"
          @click="openBankPay(row)"
          >确认打款</el-button
        >
        <el-button size="small" type="info" @click="viewPayeeAccount(row)"
          >查看账号</el-button
        >
      </template>
    </auto-table>

    <!-- 提现单详情 -->
    <el-dialog title="提现单详情" :visible.sync="detailShow" width="60%">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="提现单号">{{
          detail.order_no
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{
          statusText(detail.status)
        }}</el-descriptions-item>
        <el-descriptions-item label="店铺">{{
          detail.shop_name || detail.shop_id
        }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{
          detail.user_mobile || detail.user_id
        }}</el-descriptions-item>
        <el-descriptions-item label="提现金额(元)">{{
          detail.amount
        }}</el-descriptions-item>
        <el-descriptions-item label="手续费(元)">{{
          detail.fee
        }}</el-descriptions-item>
        <el-descriptions-item label="实际打款(元)">{{
          detail.actual_amount
        }}</el-descriptions-item>
        <el-descriptions-item label="打款渠道">{{
          detail.pay_channel === 1 ? "支付宝(线上)" : "银行卡(人工)"
        }}</el-descriptions-item>
        <el-descriptions-item label="收款方式">{{
          detail.payee_type === 3 ? "银行卡" : "支付宝"
        }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{
          detail.payee_name
        }}</el-descriptions-item>
        <el-descriptions-item label="收款账号(脱敏)">{{
          detail.payee_account_masked
        }}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{
          detail.payee_bank_name || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="开户支行">{{
          detail.payee_bank_branch || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{
          detail.audit_operator_id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          detail.audit_time || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因">{{
          detail.reject_reason || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="失败原因">{{
          detail.fail_reason || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="银行流水号">{{
          detail.bank_trade_no || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="打款人">{{
          detail.payer_name || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="打款时间">{{
          detail.pay_time || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="转账凭证">
          <el-image
            v-if="detail.bank_pic"
            style="width: 100px; height: 100px"
            :src="detail.bank_pic"
            :preview-src-list="[detail.bank_pic]"
          ></el-image>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">{{
          detail.create_time
        }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{
          detail.update_time
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog title="提现审核" :visible.sync="auditShow" width="40%">
      <el-form label-width="110px">
        <el-form-item label="提现单号">{{
          curRow.order_no
        }}</el-form-item>
        <el-form-item label="提现金额">
          ¥{{ curRow.amount }}（手续费¥{{ curRow.fee }}，实际打款¥{{
            curRow.actual_amount
          }}）
        </el-form-item>
        <el-form-item label="收款账户">{{
          (curRow.payee_type === 3 ? "银行卡" : "支付宝") +
          "·" +
          curRow.payee_name
        }}</el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditStatus">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="auditStatus === 1">
          <div v-if="curRow.pay_channel === 1" style="color: #f56c6c">
            通过后将立即调用支付宝转账（真实打款），请谨慎操作
          </div>
          <div v-else style="color: #909399">
            通过后转为待人工打款，需财务线下转账并上传凭证
          </div>
        </el-form-item>
        <el-form-item label="拒绝原因" v-if="auditStatus === 2" required>
          <el-input
            type="textarea"
            :rows="4"
            v-model="reject_reason"
            maxlength="500"
            show-word-limit
            placeholder="请输入拒绝原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary" :loading="auditLoading" @click="submitAudit"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 银行卡人工打款确认 -->
    <el-dialog title="银行卡人工打款确认" :visible.sync="bankPayShow" width="40%">
      <el-form label-width="120px">
        <el-form-item label="提现单号">{{
          curRow.order_no
        }}</el-form-item>
        <el-form-item label="应打款金额">
          <span style="color: #f56c6c; font-weight: bold"
            >¥{{ curRow.actual_amount }}</span
          >
        </el-form-item>
        <el-form-item label="收款人">{{
          curRow.payee_name
        }}</el-form-item>
        <el-form-item label="收款账号">
          {{ curRow.payee_account_masked }}
          <el-button type="text" @click="viewPayeeAccount(curRow)"
            >查看完整账号</el-button
          >
        </el-form-item>
        <el-form-item label="转账凭证" required>
          <avatar-uploader
            @getImgUrl="(v) => (bank_pic = v)"
            :url="bank_pic"
          ></avatar-uploader>
        </el-form-item>
        <el-form-item label="银行流水号" required>
          <el-input
            v-model="bank_trade_no"
            placeholder="全局唯一"
          ></el-input>
        </el-form-item>
        <el-form-item label="打款人">{{ adminInfo.name }}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bankPayShow = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="bankPayLoading"
          @click="submitBankPay"
          >确认打款</el-button
        >
      </span>
    </el-dialog>

    <!-- 完整收款账号（敏感） -->
    <el-dialog
      title="收款账号（敏感信息）"
      :visible.sync="payeeShow"
      width="35%"
      @closed="clearPayeeTimer"
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="提现单号">{{
          payeeInfo.order_no
        }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{
          payeeInfo.payee_name
        }}</el-descriptions-item>
        <el-descriptions-item label="收款账号">
          <span style="font-weight: bold">{{
            payeeInfo.payee_account
          }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="开户行">{{
          payeeInfo.payee_bank_name || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="开户支行">{{
          payeeInfo.payee_bank_branch || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="应打款金额"
          >¥{{ payeeInfo.actual_amount }}</el-descriptions-item
        >
      </el-descriptions>
      <div v-if="payeeAccountCountdown > 0" style="margin-top: 10px;color: #f56c6c">
        {{ payeeAccountCountdown }} 秒后自动关闭
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payeeShow = false"
          >已知晓，关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: { firstNav: "财务管理中心", secondNav: "店铺提现管理" },
      activeName: "list",
      DataList: [],
      Total: 0,
      query: {
        shop_id: "",
        order_no: "",
        status: "",
        pay_channel: "",
        createTime: [],
      },
      waitQuery: {
        shop_id: "",
        order_no: "",
      },
      statusOptions: [
        { value: 0, label: "待审核" },
        { value: 1, label: "打款中" },
        { value: 2, label: "已拒绝" },
        { value: 3, label: "提现成功" },
        { value: 4, label: "提现失败" },
        { value: 5, label: "待人工打款" },
        { value: 6, label: "已撤销" },
      ],
      Option: [
        { name: "提现单号", value: "order_no", width: "170px" },
        { name: "店铺", value: "shop_name" },
        { name: "申请人手机号", value: "user_mobile" },
        { name: "提现金额(元)", value: "amount" },
        { name: "手续费(元)", value: "fee" },
        { name: "实际打款(元)", value: "actual_amount" },
        { name: "打款渠道", value: "pay_channel", type: "custom" },
        { name: "收款账户", value: "payee", type: "custom", width: "200px" },
        { name: "状态", value: "status", type: "custom" },
        { name: "申请时间", value: "create_time", width: "160px" },
        { name: "操作", value: "handle", type: "custom", width: "320px" },
      ],
      curRow: {},
      detailShow: false,
      detail: {},
      auditShow: false,
      auditStatus: 1,
      reject_reason: "",
      auditLoading: false,
      bankPayShow: false,
      bank_pic: "",
      bank_trade_no: "",
      bankPayLoading: false,
      payeeShow: false,
      payeeInfo: {},
      payeeAccountCountdown: 0,
      payeeTimer: null,
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.getList(1);
  },

  beforeDestroy() {
    this.clearPayeeTimer();
  },

  methods: {
    statusText(v) {
      const map = {
        0: "待审核",
        1: "打款中",
        2: "已拒绝",
        3: "提现成功",
        4: "提现失败",
        5: "待人工打款",
        6: "已撤销",
      };
      return map[v] !== undefined ? map[v] : v;
    },
    tabChange() {
      this.getList(1);
    },
    openDetail(row) {
      this.$axios({
        url: "/user/shopWithdraw/detail",
        params: {
          apply_id: row.id,
        },
      }).then((res) => {
        this.detail = res.data.data || {};
        this.detailShow = true;
      });
    },
    openAudit(row) {
      this.curRow = row;
      this.auditStatus = 1;
      this.reject_reason = "";
      this.auditShow = true;
    },
    submitAudit() {
      if (this.auditStatus === 2 && !this.reject_reason) {
        this.$message("拒绝时必须填写拒绝原因");
        return;
      }
      this.$confirm("确定提交审核结果吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.auditLoading = true;
          this.$axios({
            url: "/user/shopWithdraw/audit",
            method: "post",
            data: {
              apply_id: this.curRow.id,
              status: this.auditStatus,
              operator_id: this.adminInfo.id,
              reject_reason: this.reject_reason,
            },
          })
            .then((res) => {
              let data = res.data.data || {};
              const msgMap = {
                1: "已通过，打款结果未知，请人工核对",
                2: "已拒绝，金额已解冻",
                3: "已通过，支付宝打款成功",
                4: "打款失败，金额已解冻",
                5: "已通过，等待人工打款",
              };
              this.$message(msgMap[data.status] || "审核成功");
              this.auditShow = false;
              this.auditLoading = false;
              this.getList(1);
            })
            .catch(() => {
              this.auditLoading = false;
            });
        })
        .catch(() => {});
    },
    openBankPay(row) {
      this.curRow = row;
      this.bank_pic = "";
      this.bank_trade_no = "";
      this.bankPayShow = true;
    },
    submitBankPay() {
      if (!this.bank_pic) {
        this.$message("请上传转账凭证");
        return;
      }
      if (!this.bank_trade_no) {
        this.$message("请填写银行流水号");
        return;
      }
      this.bankPayLoading = true;
      this.$axios({
        url: "/user/shopWithdraw/confirmBankPay",
        method: "post",
        data: {
          apply_id: this.curRow.id,
          bank_pic: this.bank_pic,
          bank_trade_no: this.bank_trade_no,
          payer_id: this.adminInfo.id,
          payer_name: this.adminInfo.name,
        },
      })
        .then((res) => {
          this.$message.success("确认打款成功");
          this.bankPayShow = false;
          this.bankPayLoading = false;
          this.getList(1);
        })
        .catch(() => {
          this.bankPayLoading = false;
        });
    },
    retryTransfer(row) {
      this.$confirm(
        "重试前必须人工确认上次转账未成功，否则可能重复打款！确定重试吗",
        "警告",
        {
          confirmButtonText: "已确认，重试打款",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$axios({
            url: "/user/shopWithdraw/retryTransfer",
            method: "post",
            data: {
              apply_id: row.id,
              operator_id: this.adminInfo.id,
            },
          }).then((res) => {
            let data = res.data.data || {};
            this.$message(data.status === 3 ? "打款成功" : "打款结果未知，请人工核对");
            this.getList(1);
          });
        })
        .catch(() => {});
    },
    viewPayeeAccount(row) {
      this.$confirm(
        "查看完整收款账号属于敏感操作，将被记录审计日志，确定继续吗",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$axios({
            url: "/user/shopWithdraw/viewPayeeAccount",
            method: "post",
            data: {
              apply_id: row.id,
              operator_id: this.adminInfo.id,
            },
          }).then((res) => {
            this.payeeInfo = res.data.data || {};
            this.payeeShow = true;
            this.startPayeeTimer();
          });
        })
        .catch(() => {});
    },
    startPayeeTimer() {
      this.clearPayeeTimer();
      this.payeeAccountCountdown = 60;
      this.payeeTimer = setInterval(() => {
        this.payeeAccountCountdown--;
        if (this.payeeAccountCountdown <= 0) {
          this.payeeShow = false;
          this.clearPayeeTimer();
        }
      }, 1000);
    },
    clearPayeeTimer() {
      if (this.payeeTimer) {
        clearInterval(this.payeeTimer);
        this.payeeTimer = null;
      }
    },
    getList(v) {
      let page = v || 1;
      let url =
        this.activeName === "wait"
          ? "/user/shopWithdraw/waitingPayPage"
          : "/user/shopWithdraw/adminPage";
      let params = {
        currentPage: page,
        pageSize: 10,
      };
      if (this.activeName === "wait") {
        params.shop_id = this.waitQuery.shop_id || null;
        params.order_no = this.waitQuery.order_no || null;
      } else {
        params.shop_id = this.query.shop_id || null;
        params.order_no = this.query.order_no || null;
        params.status = this.query.status;
        params.pay_channel = this.query.pay_channel;
        if (
          this.query.createTime !== null &&
          this.query.createTime.length > 0
        ) {
          params.start_time = this.query.createTime[0] + " 00:00:00";
          params.end_time = this.query.createTime[1] + " 23:59:59";
        }
      }
      this.$axios({
        url,
        params,
      }).then((res) => {
        this.DataList = (res.data.data && res.data.data.rows) || [];
        this.Total = (res.data.data && res.data.data.total) || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
